
import { defineComponent, shallowRef, watch, computed } from 'vue'
import Icon from '@/components/Icon.vue'
import { isDemoAccount } from '@/state/accountType'
import router from '@/router'
import state from '@/state'

export default defineComponent({
  name: 'TheEarnings',
  components: {
    Icon,
  },
  setup () {
    const demoState = shallowRef(true)
    const account = computed(() => state.account)

    watch(() => isDemoAccount.value, () => {
      demoState.value = isDemoAccount.value
    }, {
      immediate: true,
    })

    const linkToInfo = () => {
      if (demoState.value) {
        return false
      }

      router.push('/trade/statement')
    }

    const linkToStyle = () => {
      if (demoState.value) {
        return false
      }

      router.push('/trade/tradeStyle')
    }

    return {
      demoState,
      account,
      linkToInfo,
      linkToStyle,
    }
  },
})
